const { port: frontendPort, hostname } = window.location;
const { backendHost, backendPort, apiPrefix = "", useSSL = false, dev = false, } = (window?.runConfig || {});
const protocol = useSSL ? "https" : "http";
const port = backendPort || frontendPort;
export const backendUrl = `${protocol}://${backendHost || hostname}${port ? `:${port}` : ""}${apiPrefix ? `/${apiPrefix}` : ""}`;
export const psSocketUrl = `${backendUrl}/workspaceHub`;
export const rsSocketUrl = `${backendUrl}/recipeScalingHub`;
export const isDev = dev;
